export default __webpack_public_path__ + "static/media/noasktimer.6d1f1a29.png";